var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#00AA78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.125C20.1981 17.1293 20.3874 17.2077 20.5304 17.3446L24.7836 21.5878C24.9224 21.7311 25 21.9226 25 22.1219C25 22.3212 24.9224 22.5127 24.7836 22.656C24.6429 22.7962 24.4521 22.875 24.2532 22.875C24.0543 22.875 23.8635 22.7962 23.7228 22.656L20 18.942L16.2772 22.656C16.1365 22.7962 15.9457 22.875 15.7468 22.875C15.5479 22.875 15.3571 22.7962 15.2164 22.656C15.0776 22.5127 15 22.3212 15 22.1219C15 21.9226 15.0776 21.7311 15.2164 21.5877L19.4696 17.3446C19.6126 17.2077 19.8019 17.1293 20 17.125V17.125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFold);
export default __webpack_public_path__ + "static/media/fold.57db37e8310cd3f3d947fa9ba52e2709.svg";
export { ForwardRef as ReactComponent };